module.exports = __webpack_public_path__ + "img/INRAE.1aa5f2fd.jpg";